import {useEffect, useState} from "react";

export const useMediaQuery = mq => {
    const [match, setMatch] = useState(() => {
        if (typeof window !== "undefined" && window.matchMedia) {
            return window.matchMedia(mq).matches;
        }
        return false;
    });

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) return;
        const media = window.matchMedia(mq);
        setMatch(media.matches);

        const listener = () => setMatch(media.matches);
        media.addEventListener("change", listener);

        return () => media.removeEventListener("change", listener);
    }, [mq]);

    return match;
};